module.exports = __webpack_public_path__ + "static/media/tire-right.3901f597.svg";